import React from "react";
import dayjs from "dayjs";
import { DateRange, DateRangePicker } from "Components/Shared/DateRangePicker/DateRangePicker";
import { useRewards } from "../../useRewards";

export const RewardsDatePicker = () => {
  const { beginDate, endDate, onChangeDateRange } = useRewards();

  const selectedRange: DateRange = {
    start: beginDate ? dayjs(beginDate).toDate() : null,
    end: endDate ? dayjs(endDate).toDate() : null,
  };

  const handleDatePickerValueChange = (range: DateRange) => {
    onChangeDateRange({
      beginDate: range.start,
      endDate: range.end,
    });
  };

  return (
    <DateRangePicker
      selectedRange={selectedRange}
      onDateRangeChange={handleDatePickerValueChange}
      maxDate={null}
      minDate={null}
    />
  );
};
